import i18next from "i18next";
import { derived } from "svelte/store";
import { createI18nStore } from "svelte-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationsEn from "./locales/en.json";
import translationsRu from "./locales/ru.json";
const resources = {
    en: { translations: translationsEn },
    ru: { translations: translationsRu },
};
// The same set the main site serves under `/{locale}/`, so the handoff URL can
// carry whatever the patient picked here.
const SUPPORTED_LANGUAGES = ["en", "ru"];
i18next.use(LanguageDetector).init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "translations",
    detection: {
        // `ru-RU` is what Chrome reports for a Russian-locale install, and it
        // matches no supported tag: i18next then prefers the lower-priority `en`
        // the same detector found in `navigator.languages`, and a Russian patient
        // gets the English widget and the English offer. Stripping the region as
        // the tags are detected keeps `i18next.language` one of the two we serve.
        convertDetectedLanguage: (lng) => lng.split("-")[0],
    },
    interpolation: {
        escapeValue: false, // not needed for svelte as it escapes by default
    },
});
export const changeLanguage = async (lng, cb) => {
    localStorage.setItem("i18nextLng", lng);
    await i18next.changeLanguage(lng);
    cb === null || cb === void 0 ? void 0 : cb(lng);
};
// Both the doctor profile and the main site take a bare language tag, while
// the detector may resolve a regional one (`ru-RU`).
export const getLanguage = () => {
    const lng = (i18next.resolvedLanguage || i18next.language || "").split("-")[0];
    return SUPPORTED_LANGUAGES.includes(lng) ? lng : "en";
};
export const onLanguageChange = (cb) => {
    i18next.on("languageChanged", cb);
    return () => i18next.off("languageChanged", cb);
};
export const i18n = createI18nStore(i18next);
// `i18n` is re-set on every `languageChanged`, so a component that only needs
// the current tag can read it reactively instead of subscribing itself.
export const language = derived(i18n, getLanguage);
